import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { CREATORS } from "@/data/site";
import { Reveal, StaggerItem } from "@/components/Reveal";

const CreatorsStrip = ({ full = false }) => {
  const { t, tr } = useLang();
  const list = full ? CREATORS : CREATORS.slice(0, 4);

  return (
    <section id="creators" className="bg-skywash border-b border-ink py-20 md:py-28" data-testid="creators">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <p className="kicker text-pink">{t.creatorsKicker}</p>
            <h2 className="display uppercase text-5xl md:text-7xl leading-[0.85] mt-3 max-w-2xl text-brand">{t.creatorsTitle}</h2>
          </div>
          <p className="max-w-sm text-lg font-medium text-ink/70">{t.creatorsSub}</p>
        </Reveal>

        <StaggerItem className="mt-12">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ink border border-ink">
            {list.map((c, i) => (
              <Link key={c.handle} to={`/creator/${c.slug}`} className="group bg-cream block" data-testid={`creator-${i}`}>
                <div className="relative aspect-[3/4] overflow-hidden bg-sand border-b border-ink">
                  <img src={c.image} alt={c.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
                  <span className="absolute top-3 left-3 kicker text-[10px] px-2 py-0.5 border border-ink rounded-full text-ink" style={{ backgroundColor: c.color }}>
                    {tr(c.role)}
                  </span>
                  <span className="absolute bottom-3 right-3 bg-cream/90 border border-ink rounded-full px-2 py-0.5 text-xs font-bold text-ink">{c.followers}</span>
                </div>
                <div className="p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="display uppercase text-xl leading-none">{c.name}</p>
                      <p className="text-ink/50 text-sm">{c.handle}</p>
                    </div>
                    <ArrowUpRight className="w-5 h-5 text-pink transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
                  </div>
                  <p className="mt-3 text-sm text-ink/60 italic">“{tr(c.quote)}”</p>
                  <p className="mt-3 kicker text-[11px]" style={{ color: c.color }}>
                    {t.fights}: {tr(c.fights)}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </StaggerItem>

        {!full && (
          <Reveal className="mt-10 text-center">
            <Link to="/creators" className="btn-ghost h-13 px-8 py-4 inline-flex bg-cream">
              {t.creatorPage.more} <ArrowUpRight className="w-5 h-5" strokeWidth={2} />
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default CreatorsStrip;
